import React from "react";
import { useLogout } from "@refinedev/core";
import { Result, Button, Spin } from "antd";
import { useCurrentEmployee } from "../contexts/useCurrentEmployee";

export const EmployeeGate: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { employee, isLoading } = useCurrentEmployee();
  const { mutate: logout } = useLogout();

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  if (!employee) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Result
          status="403"
          title="Brak dostępu"
          subTitle="Twoje konto nie jest powiązane z żadnym pracownikiem. Skontaktuj się z administratorem."
          extra={
            <Button type="primary" onClick={() => logout()}>
              Wyloguj
            </Button>
          }
        />
      </div>
    );
  }

  return <>{children}</>;
};
